import { useEffect, useContext, useState, useCallback, FC } from 'react'

import { Loader } from 'components'
import MessageCenterChatManagerContext from './Context'
import { MessageCenterMessage, MessageCenterChat, MessageCenterRoutes } from '../../types'

type Props = {
  routes: MessageCenterRoutes
  children: JSX.Element
}

const MessageCenterChatManagerProvider: FC<Props> = ({ children, routes }) => {
  const [loadingMessages, setLoadingMessages] = useState(true)
  const [loadingChat, setLoadingChat] = useState<boolean>(true)
  const [messages, setMessages] = useState<MessageCenterMessage[]>([])
  const [chat, setChat] = useState<MessageCenterChat>({})

  const loadChatMessages = useCallback(async () => {
    setLoadingMessages(true)
    const response = await routes.readMessages()
    if (response?.header?.success) {
      const chatMessages = response?.body?.case_chat_message?.elements as MessageCenterMessage[]
      setMessages(chatMessages || [])
    }
    setLoadingMessages(false)
  }, [])

  const loadChat = useCallback(async () => {
    setLoadingChat(true)
    const response = await routes.getChat()
    if (response?.header?.success) {
      const chat = response?.body?.case_chat as MessageCenterChat
      setChat(chat || {})
    }
    setLoadingChat(false)
  }, [])

  useEffect(() => {
    if (!chat.id) loadChat()
  }, [chat])

  useEffect(() => {
    if (chat.id) loadChatMessages()
  }, [chat])

  if (loadingChat) {
    return <Loader text="Carregando chat" />
  }

  if (loadingMessages) {
    return <Loader text="Carregando mensagens do chat" />
  }

  return (
    <MessageCenterChatManagerContext.Provider
      value={{
        chat,
        setChat,
        messages,
        setMessages,
        routes,
      }}
    >
      {children}
    </MessageCenterChatManagerContext.Provider>
  )
}

export const useMessageCenterChatManager = () => useContext(MessageCenterChatManagerContext)

export default MessageCenterChatManagerProvider
